import type { ICellRendererParams } from 'ag-grid-community';

import { useCrmUrl } from '@/utils/crm-url';

import { FertilizationDonorScheduleType } from '../types';

export const DonorAspiration = ({
  value,
  data,
}: ICellRendererParams<FertilizationDonorScheduleType>) => {
  const baseUrl = useCrmUrl();
  if (!baseUrl) {
    return value;
  }

  if (data?.aspirationPoolID) {
    const url = new URL('main.aspx', baseUrl);
    url.searchParams.set('etc', '10104');
    url.searchParams.set(
      'extraqs',
      'formid=d62f735b-12e5-44f9-a104-44bc2b86f415',
    );
    url.searchParams.set('id', `{${data.aspirationPoolID}}`);
    url.searchParams.set('pagetype', 'entityrecord');

    return (
      <a href={url.toString()} target="_blank" rel="noopener noreferrer">
        {value}
      </a>
    );
  }

  const url = new URL('main.aspx', baseUrl);
  url.searchParams.set('etc', '10006');
  url.searchParams.set(
    'extraqs',
    'formid=473bcbc8-4355-4514-a75b-1ca8e4dff951',
  );
  url.searchParams.set('id', `{${data?.aspirationID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
